import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axios';

export const fetchEstimates = createAsyncThunk(
  'estimates/fetchEstimates',
  async ({ search, page, page_size }) => {
    const params = {};

    if (search) params.search = search;

    params.page = page;
    params.page_size = page_size;

    const response = await axiosInstance.get('/estimates', { params: params });

    return {
      data: response.data,
      total: response.headers['x-total-count'],
    }
  }
)

const estimatesSlice = createSlice({
  name: 'estimates',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEstimates.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchEstimates.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchEstimates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
})

export default estimatesSlice.reducer;